const onScrollBanner = document.querySelector('.on-scroll-banner');

if (onScrollBanner) {
  attachEvent('.on-scroll-banner__close', 'click', (ev) => {
    const parentEle = ev.target.closest('.on-scroll-banner');
    const bannerCookie = parentEle.getAttribute('data-banner-cookie');
    parentEle.classList.add('is-closed');
    ev.preventDefault();
    Cookies.set(bannerCookie, true, { expires: 1 });
  });

  const onScrollBannerCookie = onScrollBanner.getAttribute('data-banner-cookie');
  if (!Cookies.get(onScrollBannerCookie) && onScrollBanner) {
    onScrollBanner.classList.add('show');
    const onScrollBannerButton = onScrollBanner.querySelector('.on-scroll-banner__button .btn');
    onScrollBannerButton.addEventListener('click', (ev) => {
      ev.preventDefault();
    });

    const formAlreadyExists = onScrollBanner.querySelector('.on-scroll-banner__button .form-already-exists');
    if (formAlreadyExists) {
      formAlreadyExists.addEventListener('click', (ev) => {
        ev.preventDefault();
        const formModal = document.querySelector('.hero-sub-page--single-page .form-modal');

        if (formModal) {
          formModal.classList.add('is-open-modal');
        }
      });
    }
  }

  // Visible After Hero Sub Page Module On Page
  const heroSubPage = document.querySelectorAll('.hero-sub-page__inner');

  if (heroSubPage && onScrollBanner) {
    const sectionObserve = new IntersectionObserver(
      (entries) => {
        const onScrollCookie = Cookies.get('event-on-scroll-banner-form') ?? false;
        if (!onScrollCookie) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              onScrollBanner.classList.add('is-hidden');
            } else {
              onScrollBanner.classList.remove('is-hidden');
            }
          });
        }
      },
      { threshold: 0 },
    );

    heroSubPage.forEach((element) => {
      sectionObserve.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      if (onScrollBanner) {
        onScrollBanner.removeAttribute('hidden');
      }
    }, 300);
  });
}
